import { useParams } from 'react-router-dom';

export function ContestDetail() {
  const { contestId } = useParams<{ contestId: string }>();
  return (
    <main style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <h1>Contest {contestId}</h1>
      <p>Placeholder. Wires up to /api/v1/contests/:id in FANT-20.</p>
    </main>
  );
}
